// @ts-ignore
import Marker from "react-mark.js/Marker";
import useObservable from '../../hooks/useObservable';
import SearchStore from '../../xstores/search';

const limiters = "/:;.,-–—‒_(){}[]!'`’\"+=".split("");

const HighlightMarker = ({ as, children }: any) => {
  const highlightWords = useObservable(SearchStore.highlights$, []);
  return (
    <Marker as={as} mark={highlightWords} options={{
      ignorePunctuation: limiters,
      accuracy: {
        value: 'exactly',
        limiters
      }
    }}>
      {children}
    </Marker>
  )
}

export default HighlightMarker;